import React from 'react';

export const shadowsArr = [
  {
    background: '#E6DEDC',
    color: '#EBA89F',
    textShadowColor: '#2E2B32',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '1em',
      fontSize: '1.8em'
    }}>
      DO
      <br />
      ALL
      <br />
      THINGS
      <br />
      WITH
      <br />
      LOVE
    </div>,
    fontFamily: 'Amatic SC',
    shadowAngle: 'right',
    fontSize: '3em'
  },
  {
    background: '#A0CBA4',
    color: '#D5E2D6',
    textShadowColor: '#4A744D',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '0.8em',
      fontSize: '2em',
    }}>
      Play
      <div style={{
          fontSize: '0.5em',
          lineHeight: '0.5em'
        }}>
        at
      </div>
      your
      <div style={{
          fontSize: '0.5em',
          lineHeight: '0.5em'
        }}>
        own
      </div>
        risk
    </div>,
    fontFamily: 'Lobster',
    shadowAngle: 'right',
  },
  {
    background: '#4CC3CE',
    color: '#FFDA47',
    textShadowColor: '#105357',
    text: <div style={{
      fontSize: '40px',
      lineHeight: '60px'
    }}>
    If you get
    <div style={{
        fontSize: '128px',
        lineHeight: '120px'
      }}>
      tired
    </div>
    learn to
    <div style={{
        fontSize: '128px',
        lineHeight: '120px'
      }}>
      rest
    </div>
    not to quit
    </div>,
    fontFamily: 'Sacramento',
    shadowAngle: 'left',
  },
  {
    background: '#FFF6E6',
    color: '#F77683',
    textShadowColor: '#E7DCD7',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '200px',
      fontSize: '90px',
      textShadow: '-.030em .030em #FFF6E6, -.08em .08em #E7DCD7'
      }}>
      Believe!
    </div>,
    fontFamily: 'Comfortaa',
    shadowAngle: 'right',
    shadowLength: 10,
    offset: true,
    offsetShadow: '-.030em .030em #FFF6E6, -.08em .08em #E7DCD7',
  },
  {
    background: '#E76F33',
    color: '#E76F33',
    textShadowColor: '#3B2414',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '40px',
      fontSize: '70px'
      }}>
      Forever is composed of nows
    </div>,
    fontFamily: 'Caveat',
    shadowAngle: 'right',
    shadowLength: 120,
  },
  {
    background: '#EFC001',
    color: '#E0E1E5',
    textShadowColor: '#0E1B23',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '80px',
      fontSize: '100px',
      textAlign: 'center'
    }}>
      BE BRAVE.<br />TAKE RISKS.
    </div>,
    fontFamily: 'Fredoka One',
    shadowAngle: 'left',
    shadowLength: 150
  },
  {
    background: '#FD9597',
    color: '#FFFFFF',
    textShadowColor: '#44090D',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '50px',
      fontSize: '60px',
      textAlign: 'center'
    }}>
      Prove yourself
      <div style={{
        fontSize: '30px',
        lineHeight: '30px'
      }}>
      to
      </div>
      yourself
      <div style={{
        fontSize: '30px',
        lineHeight: '40px'
      }}>
      not others
      </div>
    </div>,
    fontFamily: 'Fugaz One',
    shadowAngle: 'left',
  },
  {
    background: '#83FBD5',
    color: '#FDF25C',
    textShadowColor: '#1142FF',
    text: <div style={{
      fontWeight: 500,
      lineHeight: '60px',
      fontSize: '70px'
    }}>
      Make today amazing
    </div>,
    fontFamily: 'Monoton',
    shadowAngle: 'left',
    shadowLength: 120
  },
  {
    background: '#E14840',
    color: '#D8F7FA',
    textShadowColor: '#020F60',
    text: <div style={{
      fontWeight: 500,
      lineHeight: '60px',
      fontSize: '70px'
    }}>
      Always
      <div style={{
        fontWeight: 500,
        lineHeight: '30px',
        fontSize: '40px'
      }}>be a</div>
      work
      <div style={{
        fontWeight: 500,
        lineHeight: '30px',
        fontSize: '40px'
      }}>in</div>
      progress
    </div>,
    fontFamily: 'Limelight',
    shadowAngle: 'right',
  },
  {
    background: '#FFF301',
    color: '#ED008C',
    textShadowColor: '#000000',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '60px',
      fontSize: 90
    }}>
    Wake <br />the <br/> fuck <br />up!
    </div>,
    fontFamily: 'Permanent Marker',
    shadowAngle: 'right',
    shadowLength: 200
  },
  {
    background: '#FC235F',
    color: '#FFFFFF',
    textShadowColor: '#000000',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '80px',
      fontSize: 90,
      textShadow: '-.02em .02em #FC235F, -.09em .09em #000000'
    }}>
    Don't<br />STOP <br />until <br />you're<br /> PROUD
    </div>,
    fontFamily: 'News Cycle',
    shadowAngle: 'left',
    shadowLength: 180,
    offset: true,
    offsetShadow: '-.02em .02em #FC235F, -.09em .09em #000000',
  },
  {
    background: '#EDEEE9',
    color: '#EDEEE9',
    textShadowColor: '#3E3E40',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '70px',
      fontSize: 60,
      textAlign: 'left'
    }}>
    It's <br />not the<br/> length<br/> of life <br/>but the <br/>depth<br/> of life
    </div>,
    fontFamily: 'Georgia',
    shadowAngle: 'left',
    shadowLength: 170
  },
  {
    background: '#1E2337',
    color: '#EFF9EE',
    textShadowColor: '#DCA84D',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '80px',
      fontSize: 90,
    }}>
    do
    <br />
    whatever
    <br />
    it
    <br />
    takes
    </div>,
    fontFamily: 'Knewave',
    shadowAngle: 'right',
    shadowLength: 20
  },
  {
    background: '#2CFECB',
    color: '#FD787A',
    textShadowColor: '#402929',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '60px',
      fontSize: 50,
    }}>
    Doubt kills more dreams than failure ever will
    </div>,
    fontFamily: 'Share Tech Mono',
    shadowAngle: 'left',
  },
  {
    background: '#FF7BAC',
    color: '#FFFFFF',
    textShadowColor: '#000000',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '60px',
      fontSize: 60,
    }}>
    Go the extra mile, it's never crowded
    </div>,
    fontFamily: 'Neucha',
    shadowAngle: 'right',
    shadowLength: 200
  },
  {
    background: '#B1A59C',
    color: '#ECF5FF',
    textShadowColor: '#2B5C6D',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '60px',
      fontSize: 60,
    }}>
    Great things never came from comfort zones
    </div>,
    fontFamily: 'Calligraffitti',
    shadowAngle: 'left',
    shadowLength: 200
  },
  {
    background: '#1C2336',
    color: '#C0C51F',
    textShadowColor: '#2D3958',
    text: <div style={{
      lineHeight: '105px',
      fontSize: 100,
      textShadow: '-.08em .08em #2D3958',
    }}>
      Don't<br />look <br />back
    </div>,
    fontFamily: 'Slabo 27px',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.08em .08em #2D3958',
  },
  {
    background: '#E9EEF2',
    color: '#46427F',
    textShadowColor: '#C9D5DB',
    text: <div style={{
      lineHeight: '105px',
      fontSize: 100,
      textShadow: '-.08em .08em #C9D5DB',
    }}>
      Stars can't shine without darkness
    </div>,
    fontFamily: 'Parisienne',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.08em .08em #C9D5DB',
  },
  {
    background: '#040404',
    color: '#FDFDFD',
    textShadowColor: '#E3B8D3',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '60px',
      fontSize: 60,
    }}>
    ONE DAY
    <div style={{
      fontWeight: 600,
      lineHeight: '30px',
      fontSize: 30,
    }}>
      or
    </div>
    DAY ONE
    <div>
      You decide.
    </div>
    </div>,
    fontFamily: 'Dancing Script',
    shadowAngle: 'left',
  },
  {
    background: '#94D5FF',
    color: '#FCFFFF',
    textShadowColor: '#F11D4F',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '55px',
      fontSize: 60,
    }}>
    don't<br />
    look<br/>
    back<br/>
    you're<br/>
    not<br/>
    going<br/>
    that<br/>
    way<br/>
    </div>,
    fontFamily: 'Roboto',
    shadowAngle: 'left',
    shadowLength: 50
  },
  {
    background: '#F24F50',
    color: '#2DFFD0',
    textShadowColor: '#222222',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
    }}>
      Forget the mistake.
      <div>
        Remember the lesson.
      </div>
    </div>,
    fontFamily: 'Lora',
    shadowAngle: 'right',
  },
  {
    background: '#BC5D3F',
    color: '#E4DAD8',
    textShadowColor: '#242B2E',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '105px',
      fontSize: 100,
      marginBottom: 40,
      textShadow: '-.2em .2em #242B2E'
    }}>
      you can.
    </div>,
    fontFamily: 'Pacifico',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.2em .2em #242B2E',
  },
  {
    background: '#02B8D8',
    color: '#FFFFFF',
    textShadowColor: '#0199D9',
    text: <div style={{
      lineHeight: '95px',
      fontSize: 90,
      textShadow: '-.08em .08em #0199D9',
    }}>
      Do it with passion
    </div>,
    fontFamily: 'Paytone One',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.08em .08em #0199D9',
  },
  {
    background: '#3A3A43',
    color: '#C4B7A6',
    textShadowColor: '#1F1E23',
    text: <div style={{
      lineHeight: '105px',
      fontSize: 100,
      textShadow: '-.08em .08em #1F1E23',
    }}>
      Work<br/>Hard<br/>Stay<br/>Humble
    </div>,
    fontFamily: 'Hammersmith One',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.08em .08em #1F1E23',
  },
  {
    background: '#3D51DE',
    color: '#E1EFF2',
    textShadowColor: '#090D27',
    text: <div style={{
      lineHeight: '75px',
      fontSize: 70,
      textShadow: '-.08em .08em #090D27',
      textAlign: 'left'
    }}>
      Follow <br />
      One<br />
      Course<br />
      Until<br />
      Successful<br />
    </div>,
    fontFamily: 'Asap',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.08em .08em #090D27',
  },
  {
    background: '#EE666B',
    color: '#FFF9F4',
    textShadowColor: '#94505A',
    text: <div style={{
      lineHeight: '65px',
      fontSize: 60,
    }}>
      The secret to getting ahead is getting started
    </div>,
    fontFamily: 'Josefin Sans',
    shadowAngle: 'left',
  },
  {
    background: '#F7F2DF',
    color: '#E63B1D',
    textShadowColor: '#231F20',
    text: <div style={{
      lineHeight: '65px',
      fontSize: 60,
    }}>
      Broken crayons still color
    </div>,
    fontFamily: 'Coming Soon',
    shadowAngle: 'left',
    shadowLength: 200
  },
  {
    background: '#F9EAE3',
    color: '#F7E1D6',
    textShadowColor: '#313036',
    text: <div style={{
      lineHeight: '105px',
      fontSize: 100,
    }}>
      get out of <br />your own way
    </div>,
    fontFamily: 'Just Another Hand',
    shadowAngle: 'left',
  },
  {
    background: '#000000',
    color: '#000000',
    textShadowColor: '#E9B336',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '105px',
      fontSize: 100,
    }}>
      MAKE IT HAPPEN
    </div>,
    fontFamily: 'Oswald',
    shadowAngle: 'left',
    marginBottom: 50,
    shadowLength: 200
  },
  {
    background: '#101B1F',
    color: '#F8FFFF',
    textShadowColor: '#C5394A',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
    }}>
      If your <br/> dreams <br/>don't <br/>scare you, <br/>they aren't <br/>BIG ENOUGH
    </div>,
    fontFamily: 'Dosis',
    shadowAngle: 'right',
  },
  {
    background: '#8DB250',
    color: '#F8FAF8',
    textShadowColor: '#095933',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
    }}>
      You didn't <br/>come<br /> this far<br/> to only<br/> come <br/>this far
    </div>,
    fontFamily: 'Abel',
    shadowAngle: 'left',
  },
  {
    background: '#E81A23',
    color: '#ffffff',
    textShadowColor: '#E1D600',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
      textTransform: 'uppercase'
    }}>
      You  <br /> only <br /> fail <br />when <br />you<br />stop<br />trying
    </div>,
    fontFamily: 'Khand',
    shadowAngle: 'right',
  },
  {
    background: '#FEE97F',
    color: '#FFFDD8',
    textShadowColor: '#065DAE',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
    }}>
      the darkest nights produce the brightest stars
    </div>,
    fontFamily: 'Kalam',
    shadowAngle: 'left',
    shadowLength: 200
  },
  {
    background: '#E1E1E1',
    color: '#00C0FF',
    textShadowColor: '#434343',
    text: <div style={{
      lineHeight: '95px',
      fontSize: 90,
      fontWeight: 600
    }}>
      Don't wait
    </div>,
    fontFamily: 'Ubuntu',
    shadowAngle: 'left',
    shadowLength: 220
  },
  {
    background: '#EEEEEE',
    color: '#707070',
    textShadowColor: '#707070',
    text: <div style={{
      lineHeight: '75px',
      fontSize: 70,
      textShadow: '-.030em .030em #EEEEEE, -.06em .06em #707070',
    }}>
      If you do nothing, nothing changes.
    </div>,
    fontFamily: 'Erica One',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.030em .030em #EEEEEE, -.06em .06em #707070',
  },
  {
    background: '#89D3D6',
    color: '#FFFFFF',
    textShadowColor: '#2D3E50',
    text: <div style={{
      lineHeight: '95px',
      fontSize: 90,
      textShadow: '-.030em .030em #89D3D6, -.09em .09em #2D3E50',
    }}>
      Nothing works unless you do
    </div>,
    fontFamily: 'Muli',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.030em .030em #89D3D6, -.09em .09em #2D3E50',
  },
  {
    background: '#823A86',
    color: '#FA7399',
    textShadowColor: '#5E2962',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '65px',
      fontSize: 60,
    }}>
      WORK<br/>HARD<br/>STAY<br/>HUMBLE
    </div>,
    fontFamily: 'Lato',
    shadowAngle: 'left',
  },
  {
    background: '#6A949E',
    color: '#D7818A',
    textShadowColor: '#484A46',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '85px',
      fontSize: 80,
      textTransform: 'uppercase'
    }}>
      Prove<br/>Them<br/>Wrong
    </div>,
    fontFamily: 'Special Elite',
    shadowAngle: 'left',
  },
  {
    background: '#484746',
    color: '#EBEBED',
    textShadowColor: '#F07E51',
    text: <div style={{
      fontWeight: 600,
      lineHeight: '85px',
      fontSize: 80,
      textTransform: 'uppercase'
    }}>
      You<br/> are<br/> your<br/> only<br/> limit<br/>
    </div>,
    fontFamily: 'Cabin Sketch',
    shadowAngle: 'left',
  },
  {
    background: '#A1E5A2',
    color: '#2860DA',
    textShadowColor: '#0199D9',
    text: <div style={{
      lineHeight: '55px',
      fontSize: 60,
      textShadow: '-.03em .03em #182642',
    }}>
      Consistency <br/>= <br/>Success
    </div>,
    fontFamily: 'Paytone One',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.03em .03em #182642',
  },
  {
    background: '#354962',
    color: '#FFFFFF',
    textShadowColor: '#2A3D4E',
    text: <div style={{
      lineHeight: '95px',
      fontSize: 90,
    }}>
      Try,<br />
      try,<br />
      try.<br />

    </div>,
    fontFamily: 'Paytone One',
    shadowAngle: 'left',
    shadowLength: 10
  },
  {
    background: '#2D2D2D',
    color: '#B7A718',
    textShadowColor: '#E5E1BD',
    text: <div style={{
      lineHeight: '95px',
      fontSize: 90,
      textShadow: '-.030em .030em #2D2D2D, -.06em .06em #E5E1BD',
    }}>
      Fall seven times, get up eight
    </div>,
    fontFamily: 'Merriweather',
    shadowAngle: 'left',
    offset: true,
    offsetShadow: '-.030em .030em #2D2D2D, -.06em .06em #E5E1BD',
  },
];



// WEBPACK FOOTER //
// ./src/pages/projects/shadows/ShadowsConstants.jsx